import React from "react";
import { PublicVisitBroadcastDetailsTypes } from "../messages";
import AvailableFlexibleDatesHeader from "./AvailableFlexibleDatesHeader";
import AvailableFlexibleShift from "./AvailableFlexibleShift";
import { AppList } from "./Generic/AppList";
import { FlexibleVisitProps } from "./useFlexibleVisit";

interface Props {
  visit: PublicVisitBroadcastDetailsTypes.FlexiblePattern;
  showSelectAll: boolean;
  flexibleVisitProps: FlexibleVisitProps;
  choiceCounterHeaderTitle: string | null;
}

const AvailableFlexibleDates = (props: Props) => {
  return (
    <AppList bordered={true}>
      <AvailableFlexibleDatesHeader
        {...props}
        areAllShiftsChecked={props.flexibleVisitProps.areAllDaysChecked}
        headerTitle={props.choiceCounterHeaderTitle}
        showSelectAll={props.showSelectAll}
        onToggleAllDays={props.flexibleVisitProps.onToggleAllDays}
      />
      {props.flexibleVisitProps.days.map(({ state, calculated }) => (
        <AvailableFlexibleShift
          key={calculated.day.toString()}
          day={calculated.day}
          isChecked={state.isChecked}
          isDisabled={state.isDisabled}
          startTime={state.startTime}
          durations={state.durations}
          endTime={state.endTime}
          areTimesFlexible={props.flexibleVisitProps.areTimesFlexible}
          isSelectedTimeInAvailabilityRange={calculated.isSelectedTimeInAvailabilityRange}
          isValidRange={calculated.isValidRange}
          durationInHours={calculated.durationInHours}
          firstDuration={calculated.firstDuration}
          isDurationSelected={calculated.isDurationSelected}
          isOvernight={calculated.isOvernight}
          knownDurationInHours={calculated.knownDurationInHours}
          minStartTime={calculated.minStartTime}
          showTimesLabel={calculated.showTimesLabel}
          startsToday={calculated.startsToday}
          onToggleDay={props.flexibleVisitProps.onToggleDay}
          onSelectDuration={props.flexibleVisitProps.onSelectDuration}
          onChangeStartTime={props.flexibleVisitProps.onUpdateTime}
        />
      ))}
    </AppList>
  );
};

export default AvailableFlexibleDates;
